import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import Image, { useFallbackImageSrc } from '../Image/Image';
import { trackCheckoutStart, trackEvent } from '../Tracking/Matomo';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Currency from '../../../helpers/currency';
import Button from '../form-elements/Button';
import { InternalEventLink } from '../form-elements/Link';
import { useStandortHistory } from '../VHost/StandortHistory';
import { addService } from '../../../modules/actions/standort/session/cart';
import { useParams } from 'react-router-dom';

function ServiceListRow({ service }) {
     const { kategorie } = service;
    let { serviceUrl } = useParams();
    if(serviceUrl === undefined){
        serviceUrl = kategorie;
    }
    const history = useStandortHistory();
    const dispatch = useDispatch();
    const markenStandort = useSelector(markenStandortSelector);

    const fallbackSrc = `https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}/Logo.jpg`;

    const [serviceImageSrc, angebotImageOnError] = useFallbackImageSrc({
        src: service.bilddatei,
        fallbackSrc,
    });

    const addServiceToCart = async evt => {
        try {
            evt.preventDefault();
            trackEvent({
                category: 'E-Commerce',
                action: 'Lege-in-Warenkorb',
                label: `${service.fahrzeugBeschreibung}_${service.serviceTitle}`,
            });
            await dispatch(addService({ service }));
            trackCheckoutStart({ legalType: 'reservierung' });
            history.push(`/initiateCheckout?type=reservierung`);
        } catch (err) {
            window.UIkit.notification(err.message, { status: 'danger', pos: 'top-right' });
        }
    };

    return (
        <>
            <div className="uk-grid uk-grid-small" data-uk-grid="">
                <div className="uk-width-1-4@m uk-width-1-1">
                    <div className="uk-flex uk-flex-center uk-position-relative">
                        <div>
                            <div className="uk-flex uk-flex-middle" style={{ height: 160 }}>
                                {!service.bilddatei ? (
                                    <Image style={{ maxHeight: 160 }} src={fallbackSrc} alt="Standort" resizeHeight={160} />
                                ) : (
                                    <Image
                                        style={{ maxHeight: 160 }}
                                        src={serviceImageSrc}
                                        alt={`Vorschaubild: ${service.serviceTitle}${service.fahrzeugBeschreibung ? ` - ${service.fahrzeugBeschreibung}` : ''}`}
                                        resizeHeight={160}
                                        onError={angebotImageOnError}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="uk-width-expand">
                    <h2 className="uk-margin-remove-top">
                        <div dangerouslySetInnerHTML={{ __html: service.serviceTitle }} />
                    </h2>
                    {service?.fahrzeugBeschreibung && <div dangerouslySetInnerHTML={{ __html: service.fahrzeugBeschreibung }} />}
                    {!isEmpty(service.angebotsBulletPoints) && (
                        <ul>
                            {service.angebotsBulletPoints.map((bulletPoint, index) => (
                                <li key={index}>
                                    <div dangerouslySetInnerHTML={{ __html: bulletPoint }} />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="uk-width-1-4@m uk-width-1-1 uk-text-center">
                    <div className="uk-margin-auto-top uk-text-center">
                        {service.preis ? (
                            <h3 className="uk-margin-remove">
                                <Currency quantity={service.preis.komplettPreis} />*
                            </h3>
                        ) : (
                            <div className="uk-tile uk-tile-muted uk-padding-small">
                                <p className="uk-text-danger uk-text-small" style={{ fontSize: '1em' }}>
                                    Finden Sie das Produkt bei einem Händler in Ihrer Nähe.
                                </p>
                            </div>
                        )}
                        <div className="uk-text-danger uk-margin-small">Komplettpreis </div>
                        <div data-uk-grid="" className="uk-grid-small uk-child-width-1-1">
                            <div>
                                <Button fullWidth onClick={addServiceToCart} modifier="secondary" ariaLabel={`${service.serviceTitle} ${service.fahrzeugBeschreibung} Reservieren`}>
                                    Reservieren
                                </Button>
                            </div>
                            <div>
                                <InternalEventLink
                                    to={`/reparatur-wartung/${serviceUrl}/${service._id}`}
                                    action="Klick-Service-Detail"
                                    label={`${service.fahrzeugBeschreibung}_${service.serviceTitle}`}
                                    fullWidth
                                    modifier="secondary"
                                    ariaLabel={`${service.serviceTitle} ${service.fahrzeugBeschreibung} Details`}
                                >
                                    Details
                                </InternalEventLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </>
    );
}

export default ServiceListRow;
